module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wordsection"
  }, [_c('h1', {
    staticClass: "textblock8",
    attrs: {
      "id": "textblock_toc_4"
    }
  }, [_c('a', {
    staticClass: "ptextblock ptextblock1 textblock5",
    attrs: {
      "id": "_Toc503463796"
    }
  }), _c('a', {
    staticClass: "ptextblock ptextblock1 textblock5",
    attrs: {
      "id": "_Toc503463554"
    }
  }), _c('a', {
    staticClass: "ptextblock ptextblock1 textblock5",
    attrs: {
      "id": "_Toc503463488"
    }
  }), _c('a', {
    staticClass: "ptextblock ptextblock1 textblock5",
    attrs: {
      "id": "a3"
    }
  }), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('h2', {
    staticClass: "textblock9"
  }, [_c('a', {
    staticClass: "ptextblock ptextblock1 textblock5",
    attrs: {
      "id": "_Toc503463489"
    }
  }), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Angelique")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("There was chatter and clatter all around me, I was sure. But I heard not a bit of it. I guess the hearts in my eyes were like buds in my ears.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I woke up thinking about u and you’re still on my mind.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("My sigh was long and deep as I read the message in my")]), _vm._v(" "), _c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Words With Friends")])]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("app again.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Well, dang.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Looking up, I had to blink a couple of times, just to get my eyes to focus on my best friend,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl. If she hadn’t been sitting across from me, if she hadn’t spoken a word, I might have just sat here in this restaurant without ordering or eating a thing, even though we were at Houston’s on Kirby, one of my favorite spots.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She said,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“Either I'm just awful company or your man is putting it down, even through texts and I’m so glad to finally hear that. Damn!” She laughed. “You got pics? Wanna share?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I laughed with her as I set my")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("phone on the table. “You’re wonderful company and no, “I sighed, “my man is not,” I paused long enough to make air quotes, “putting it down. And I certainly don’t have pictures. Can you imagine? Preston sending me nude shots?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I shuddered, and so did")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Ewww. Why did I even kid around about something like that? I mean, your husband is fine, but it would be like looking at my brother. Ewww.” She shook her shoulders as if the idea of that appalled her. Then, after taking what I assumed to be a cleansing breath, she said, “But if I’m wrong, then you need to explain why you’re acting like you never got any home training from Marie and Kelly,” she said referring to my parents.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("That made me chuckle, and once again glance down at my phone. I stuffed my fingers beneath my legs. That was the only way I wouldn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t reach for my cell just to check to see if Blu (that was his real name) had sent me another message…on top of the hundreds we’d exchanged in the last week.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I needed to keep my attention on my best friend because though we spoke on the phone and texted all the time, two months had passed since she, and the third spoke of our three-wheels, Cassidy, and I had gathered together.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("These get togethers fulfilled a promise we")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’d made when we graduated from The University of Texas at Austin — me with my double degree in French and Italian and Sheryl and Cassidy both majoring in psychology — we would have lunch or dinner at least once a month, every month, till the day we died.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Of course, we meant that vow at the time. But in the years since graduation, life had stepped in and one month had turned to two. And today, Cassidy wasn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t even here. While Sheryl had turned her psychology degree into becoming one of Houston’s most prominent psychologists with not only a thriving practice but with weekly TV appearances on various news shows, Cassidy had used her educational training to help her handle the hundreds of passengers she had to service in the friendly skies as a lead flight attendant.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She had planned to join us for this early dinner, but it seemed that one of her many")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("‘friends’ had swept her up for a quick getaway to Dubai. So, it was just me and Sheryl. And with the way she was looking at me right now, I so wished Cassidy was here to give Sheryl and her inquiring-mind-that-always-wanted-to-know, someone else to focus on.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Ahem!” She cleared her throat. “So you want to tell me why you were so rude and why now, you’re just staring at me with this goofy grin like you’re a teenager in love.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“My bad.” I waved my hand in the air, like it was nothing. My hope was that the subject would change to something that didn’t have to do with me. Because then, Sheryl wouldn’t press.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Usually, I didn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t falter under my friend’s scrutiny. Of the three, I was the most private…not on purpose. That was just the way I’d been raised. To endure all things and to remain silent. To be private to the point of almost being secretive — the way my mother had lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("But this")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("…this was something that I wanted to share. Especially since over the past four years I’d opened up (especially to Sheryl) about Preston. So, since she’d listened to hours of my distress, I wanted to tell her about what was going on with Blu and how a few innocent messages between us had morphed to a couple hundred of very flirtatious ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("\"So, what's going on?\" Sheryl asked, right as the waiter stepped to our table.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I sighed with relief. A reprieve. Time enough for me to figure out what I wanted to share.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Ladies.” The young man, who looked like Terrance Howard’s son, gave us a smile that had made some orthodontist a lot of money. “Can I start you off with drinks?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Just water for me,” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("No,” Sheryl interjected. “Two martinis. A dirty one for me and one of those girly pomegranate lemonade ones for her.” When my mouth opened wide, she said to me, “I’m a doctor. That’s my prescription to get you to tell me the truth.” To the waiter, she directed, “Bring our drinks and by the time you come back, we’ll be ready to order.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("He nodded, chuckled and then, turned to do as he")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’d been told.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Bringing her attention back to me, she said,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“Close your mouth.” She held up her hand. “No, not all the way. I want you to start talking. What’s going on?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I shook my head and laughed.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“I told you, nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I’m not going to play twenty questions with you. So here are the facts,” she said, sounding more like a psychologist than my friend. “The last time I talked to you, you were complaining about how Preston had missed the Women on the Move event. But he must've made it up to you ‘cause the way you’re grinning, he must have your kitty cat purring.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I blew out a long breath.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“I wish.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl’s eyes narrowed. “Keep talking.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Once again, I wished for Cassidy")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’s presence and wondered why I was so reluctant to share with Sheryl. Maybe it was because of what I was doing with Blu.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("In the last week, Blu and I chatted constantly. He messaged me in the morning, mid-morning, noon, afternoon, evening and night. And then, there was that one special message that he sent right before I closed my eyes:")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I hope I’ll join you in your dreams because you are always in mine.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sigh. Swoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("There was no longer any pretense with our flirting. It was straight out and straight up")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("— for both of us. He told me how he couldn’t get me off his mind and I told him that I couldn’t stop thinking about him either. He told me that he was sure he’d never met anyone like me and I told him that even though we hadn’t officially met, I felt the same.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("It had been ten days of back and forth exchanges, it had been ten days that was almost beginning to feel")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("…like a relationship.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Angelique.” Sheryl drew out my name.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("But just like a few minutes before, the waiter returned with our drinks and I once again breathed at the time I was being given to figure this out. In the couple of seconds that it took for")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl to ask about the dinner specials, then order her usual barbecued ribs with mashed potatoes and a salad, I again contemplated how much I wanted to confess.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("It wasn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t that I didn’t trust Sheryl or thought that she’d judge me in any way. She’d been by my side through any of the traumas and tragedies that I had been willing to tell her about: trifling boyfriends, drama with girlfriends, issues with Preston…and then, the ultimate — the death of my mom. She’d been the first one at our house (arriving even before Preston had come home) to give me a hug, then take over whatever I needed. There was no risk, only an upside in telling Sheryl.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("It was just that I truly didn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t know what to say to my best friend: "), _c('i', {
    staticClass: "textblock2"
  }, [_vm._v("Hey, I met this guy in this app and I think I’ve got a thing for him. And ummm…no, we’ve never met…we’ve never even spoken on the phone.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")])]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Angelique?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Huh?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Aren’t you going to order?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I blinked and looked up.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“Oh, I’m sorry.” I shook my head, then ordered the house smoked salmon and Cajun trout.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("The moment the waiter stepped away,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl said, “Okay, drink up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I took a sip of my martini only because it bought me a few more seconds.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("After she")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’d taken two sips of her own, she said, “Okay, talk up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I keep telling you, it’s nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She wagged her finger.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "IT"
    }
  }, [_vm._v("\"No ma'am")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v(".” Now, her head shook back and forth, too. “You’re gonna have to come up with a new word because ‘nothin’’ ain’t what’s going on. That smile on your lips,” she pointed to my face, “that ain't nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I chuckled at the way")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl, who was by far the most successful one of us professionally, could always bring it down back to the language of South Park, the hood where she grew up.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She kept on,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“That's the smile that you had only for Preston when he used to take care of his business. So if you’re telling me that Preston ain’t putting it down and isn’t responsible for the smile on your face, then I need to know what…or who is.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She leaned back in her chair, crossed her arms, rolled her neck, and the way she pursed her lips, I knew nothing else was going to happen until I started talking. I sighed. This was the reason why Dr.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl Roberts from South Park got paid the big bucks. Because inside her office, she got people to talk. Inside her office, she solved problems.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("So, I opened my mouth")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("…and my cell phone chimed. It was more than a habit that made me look down and pick it up — it was the anticipation and the excitement.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I clicked on the notification so that I could see Blue")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’s entire message:")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Are you finished with dinner yet? I miss you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“Oh,” I whispered and pressed my hand across my chest.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("And then, I remembered")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("…I wasn’t alone.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Dang!")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Raising my eyes slowly, my glance settled right on")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl’s glare. It was easy to see her because she was no longer sitting back. Now, she leaned forward, her head almost half-way across the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I knew I had to start talking now.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Okay,” I said. “I met someone.” Then, I held up one hand. “But he’s just a friend.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Friends don't make friends smile like that.” And then with a quickness that I didn’t expect, she snatched the phone from my hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Hey,” I said. But it was too late. She had full possession.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("My screen had darkened, but that didn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t stop Sheryl. She pressed the home button, then tapped a few keys.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("You really need to stop using your birthday as your passcode,” she said without looking up.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("And you really need to stop acting like you just stopped picking locks yesterday.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("My words didn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t faze her. She kept her eyes on the screen and my heart pounded.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She finally looked up with a frown.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("\"Okay, so are you deleting the texts right after you look at them?\" She turned my phone around to show me the empty text message screen. \"If you are, that's smart. But damn, that was quick.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("\"Would you get out of my phone?\" I snatched it back. “And I'm not deleting any texts. We're not texting.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She took another sip of her drink, but I knew that was just to give her a moment to think.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl was sure that she could figure out everything. She put her glass down. “I saw you sitting there, grinning like you just had your first kiss or your first…whatever. So what are y’all doing? Tweeting? Facebooking? You know that's how thirty-seven percent of marriages are now ending - behind social media.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("\"My marriage isn't ending because I'm not doing anything wrong,\" I said, shaking my head with every word. \"And we're not on social media. It's a game.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She frowned, then blinked.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("\"A what?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("A game.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She held up her glass and side-eyed her martini as if she")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’d had too much to drink.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I laughed.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("\"We play a game. "), _c('i', {
    staticClass: "textblock2"
  }, [_vm._v("Words with Friends")]), _vm._v(".\"")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Now,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl really looked confused with the way her eyebrows furrowed. \"So, playing a game brings a smile on your face like that? What did you do? Score one thousand points?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I wish. No. We chat while we play.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("In a game? In an app?”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Yeah.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Damn. This world of technology.” Then, after another sip, a smile spread across her face. “So you…sneaking around….”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Doing sneaky stuff.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("No…just communicating.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("She laughed.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“That’s a new word for it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Come on, Sheryl,” I said, feeling like maybe I shouldn’t have said anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I’m just sayin’ you can call it what you want, but it is what it is. And I ain’t mad at you. I told you before Preston needed to get himself together because what he won’t do, another man will.” She raised her glass as if she were toasting me and I wondered if that was her professional opinion.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I shifted my hips, suddenly not so comfortable in my seat.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“I’m really not doing anything. No man is doing anything for me. Preston has nothing to worry about.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Ummm,” Sheryl hummed. “Preston has nothing to worry about…yet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Stop saying that, don’t even think it. I haven’t even met this man. I’ve never spoken to him on the phone. Only messengering in the app.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Her martini glass was right on the edge of her lips and she froze. Then, a couple of seconds later, she returned her glass slowly to the table.")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“So wait. Your smile, this glow,” she moved her hand in a circle in front of my face, “and you ain’t even met the ninja?” She leaned back. “Damn.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I was getting ready to explain it to her, but then that sound that made me smile. I didn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t even try to hide it since I’d just told Sheryl everything. I knew I had to look like a kid at Christmas with the way I grabbed my cell and then tapped onto the app:")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Did you get my message? I miss you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I typed back:")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I got it. Still at dinner.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Not even three seconds seemed to pass:")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("One day I’d")])]), _vm._v(" "), _c('span', {
    staticClass: "textblock10",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("❤")]), _vm._v(" "), _c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("to take you to dinner.")])])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I gave myself a moment to swoon. I’d been thinking about asking Blu for his number, just so we could chat since we enjoyed each other so much through the messages. But I’d been afraid to ask, especially after he’d told me he was married. That meant that he’d just wanted to keep this a virtual thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("But now")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("…he was practically saying that he wanted to see me. I closed my eyes for a second, then, responded:")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Maybe one day we can make that happen")])]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("I smiled, pressed")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("‘Send’ — and then, the chatter and the clatter started up again around me. That quickly, for those few — what were they? Seconds? Minutes? — I’d forgotten that I was in this restaurant…with my best friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Dang!")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Slowly, I put my phone down and")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Sheryl just stared at me. And then, the waiter saved me again. For the third time. This time, he placed my meal in front of me before he served Sheryl her plate.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("When he stepped away, I said,")]), _vm._v(" "), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“I’ll bless the food,” giving myself a few more seconds before I’d have to face Dr. Roberts.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("And that")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’s just what happened. The moment I said, “Amen,” Sheryl piped in, “Aww hell no!”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Really, Sheryl. Cursing like that? I just said grace.”")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("“")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Don’t try to change the subject. You can try to tell yourself, you can try to tell me that that,” she pointed to my phone, “ain’t nothin’. But I’ll tell you this, if it’s nothing now, it’ll be something soon.” She paused. “And that’s my professional opinion. I ain’t even gonna charge you.” She sat back, did another one of those neck rolls, and pursed her lips as if she dared me to challenge her.")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("All I could do was look down at my salmon. And since my head was bowed, I decided to say another little prayer.")]), _vm._v(" "), _c('i', {
    staticClass: "textblock2"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("Please God…")])]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v(". And then, I paused. What did I want? What did I want to ask God to help me to do?")])]), _vm._v(" "), _c('p', {
    staticClass: "msonormal5"
  }, [_c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("My heart started pounding. Because if I couldn")]), _c('span', {
    staticClass: "textblock5",
    attrs: {
      "xml:lang": "EN-US"
    }
  }, [_vm._v("’t answer those questions, if I couldn’t pray to God, I had a feeling that this could lead me down a road that had been traveled by too many. A journey that I was not sure that I wanted to take.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eac9292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/final_split_005.vue
// module id = 72
// module chunks = 0